<template>
    <div class="publicList">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="top">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                      <el-breadcrumb-item v-if="isSearch">搜索"{{searchTitle}}"的结果</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
            <div class="content">
                <div class="left">
                    <sideSearch></sideSearch>

                    <div class="box1" style="margin-top: 15px;">
                        <div class="publicTop">
                            <div class="title">
                                <img src="../assets/img/index/creditKnowledge.png" alt="">
                                <span style="margin-left: 5px;">信用知识</span>
                            </div>
                            <div class="more" @click="toList('信用知识')">更多</div>
                        </div>
                        <div class="list">
                            <ul>
                                <li v-for="(item, index) in box1List" :key="index" @click="toDetail2(item, '信用知识')">
                                    <div style="display: flex;justify-content: left;align-items: center;height: 46px;line-height: 46px;padding: 0 0 0 15px;">
                                        <img src="../assets/img/index/arrows6.png" alt="">
                                        <span class="title">{{ item.title }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="box1" style="margin-top: 15px;">
                        <div class="publicTop">
                            <div class="title">
                                <img src="../assets/img/index/creditManagement.png" alt="">
                                <span style="margin-left: 5px;">信用管理</span>
                            </div>
                            <div class="more" @click="toList('信用管理')">更多</div>
                        </div>
                        <div class="list">
                            <ul>
                                <li v-for="(item, index) in box2List" :key="index" @click="toDetail2(item, '信用管理')">
                                    <div style="display: flex;justify-content: left;align-items: center;height: 46px;line-height: 46px;padding: 0 0 0 15px;">
                                        <img src="../assets/img/index/arrows6.png" alt="">
                                        <span class="title">{{ item.title }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="title">
                        <div style="width: 6px;height: 20px;border-radius: 6px;background: linear-gradient(to bottom, #1A68E8, #fff);"></div>
                        <div class="text">{{ documentTitle }}</div>
                    </div>
                    <div style="display: flex;align-items: center;background-color: #f5f5f5;margin-top: 5px;width: 55%;">
                        <img src="../assets/img/index/division3.png" alt="" style="width: 100%;">
                        <img src="../assets/img/index/division4.png" alt="" style="width: 100%;">
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in contentList" :key="index">
                                <span class="title" @click="toDetail(item)">{{ item.title }}</span>
                                <div class="look">
                                    <span v-if="item.publishTime">{{ item.publishTime.substring(0, 10) }}</span>
                                </div>
                            </li>
                        </ul>
                        <el-empty class="empty" description="未找到您想要的" v-if="empty"></el-empty>
                        <el-pagination @current-change="currentChange"
                          background
                          :current-page="page"
                          layout="prev, pager, next, jumper"
                          next-text="下一页"
                          prev-text="上一页"
                          :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../api/api'
import publicHeaders from '../components/header.vue'
import foot from '../components/foot.vue'
import sideSearch from '../components/sideSearch.vue'
export default {
    name: 'publicList',
    components: {
        publicHeaders,
        foot,
        sideSearch
    },
    data() {
        return {
            documentTitle: '',
            tree: [],
            box1List: [
                // {
                //     title: '从大众到冷门，这些 APP 经历了什么从大众到冷门，这些 APP 经历了什么'
                // },
                // {
                //     title: '从大众到冷门，这些 APP 经历了什么'
                // },
                // {
                //     title: '从大众到冷门，这些 APP 经历了什么'
                // },
                // {
                //     title: '从大众到冷门，这些 APP 经历了什么'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
            ],
            box2List: [
                // {
                //     title: '2018年度中国企业信用500强名单2018年度中国企业信用500强名单'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
            ],
            contentList: [],
            page: 1,
            total: 0,
            empty: false,
            isSearch: false,
            searchTitle: ''
        }
    },
    watch: {
      // 监听路由参数的变化
      '$route.query.documentTitle': {
        immediate: true,
        handler(newVal, oldVal) {
          // 当路由参数变化时，这里会被调用
          // 你可以在这里根据新的参数执行你的逻辑
        //   console.log('参数变化了:', newVal);
            this.documentTitle = newVal
            document.title = newVal
            this.getTree()

            this.getbox1()
            this.getbox2()
        }
      },
      '$route.query.searchName': {
        immediate: true,
        handler(newVal, oldVal) {
          // 当路由参数变化时，这里会被调用
          // 你可以在这里根据新的参数执行你的逻辑
        //   console.log('参数变化了:', newVal);
            this.documentTitle = this.$route.query.documentTitle
            document.title = this.$route.query.documentTitle
            this.getTree()

            this.getbox1()
            this.getbox2()
        }
      }
    },
    created() {
        window.scrollTo(0 ,0)
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        this.getTree()

        this.getbox1()
        this.getbox2()
    },
    methods: {
        // 获取分类
        getTree() {
            let _this = this
            this.tree = []
            let params = {}
            api.getTree().then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.tree = data.data
                    
                    if (_this.$route.query.searchName != undefined) {
                        _this.searchTitle = _this.$route.query.searchName
                        _this.isSearch = true
                        _this.getList(_this.$route.query.searchName)
                    } else {
                        _this.searchTitle = ''
                        _this.isSearch = false
                        _this.getList()
                    }
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取列表
        getList(searchTitle) {
            let _this = this
            _this.contentList = []
            let params = {
                cateId: '',
                title: '',
                page: _this.page,
                size: 10,
            }
            if (searchTitle != undefined) {
                params.title = searchTitle
            }
            _this.tree.forEach(element => {
                if (element.name == _this.documentTitle) {
                    params.cateId = element.id
                }
            });
            api.getList(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.contentList = data.data.data
                    _this.total = data.data.total
                    if (data.data.total == 0) {
                        _this.empty = true
                    } else {
                        _this.empty = false
                    }
                } else {
                    _this.empty = true
                }
            })
            .catch(error => {
                _this.empty = true
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 分页
        currentChange(val) {
            this.page = val;
            this.getList()
        },

        // 查看详情
        toDetail(item) {
            // 诚信倡议单位：跳转到企业详情页（companyId存在label字段中）
            if (item.label && !isNaN(item.label)) {
                this.$router.push({
                    name: 'starLevel',
                    query: {
                        documentTitle: this.documentTitle + '详情',
                        id: item.label
                    }
                })
                return
            }
            let title = ''
            if (this.documentTitle == '新闻中心') {
                title = '新闻详情'
            } else {
                title = this.documentTitle + '详情'
            }
            this.$router.push({
                name: 'newsDetail',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        },

        // 获取信用知识
        getbox1() {
            let _this = this
            let params = {
                cateId: 66,
                title: '',
                page: 1,
                size: 5,
            }
            api.getList(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.box1List = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取信用管理
        getbox2() {
            let _this = this
            let params = {
                cateId: 12,
                title: '',
                page: 1,
                size: 5,
            }
            api.getList(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.box2List = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        toList(title) {
            this.$router.push({
                name: 'publicList',
                query: {
                    documentTitle: title
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/publicList"
            // });
            // window.open(routeUrl.href+ '?documentTitle=' + title, '_blank');
        },

        // 前往详情
        toDetail2(item, title) {
            this.$router.push({
                name: 'newsDetail',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/newsDetail"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        }
    }
}
</script>

<style lang="less" scoped>
.publicList {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 1200px; /*no*/
        padding: 15px 0;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1200px; /*no*/
        }
        .top {
            flex: 1;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
        }
        .content {
            display: flex;
            justify-content: space-between;
            min-height: 600px;
            margin-top: 10px;
            /* width: 80vw;
            min-width: 1152px; */
            .left {
                width: 25%;
                flex: 1;
                .publicTop {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                    border: 1px solid #85B2FF;
                    background: linear-gradient(to bottom, #EAF6FF, #ECF7FF, #DEF0FF, #E9F5FF, #F6FBFF);
                    .title {
                        color: #134AA6;
                        font-size: 20px;
                        display: flex;
                        align-items: center;
                    }
                    .more {
                        color: #666;
                        cursor: pointer;
                    }
                }
                .box1 {
                    .list {
                        border: 1px solid #D9D9D9;
                        border-top: none;
                        .title {
                            margin-left: 10px;  
                            color: #666;
                            font-size: 18px;
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            cursor: pointer;
                        }
                        .title:hover {
                            color: #258AFF;
                        }
                        li:nth-of-type(n+2) {
                            border-top: 1px solid #D9D9D9;
                        }
                    }
                }
            }
            .right {
                flex: 3;
                border: 1px solid #D9D9D9;
                min-height: 750px;
                padding: 20px 30px;
                margin-left: 10px;
                width: 75%;
                .title {
                    display: flex;
                    align-items: center;
                    .text {
                        font-size: 20px;
                        color: #333;
                        margin-left: 15px;
                    }
                }
                .list {
                    position: relative;
                    ul {
                        min-height: 590px;
                    }
                    .empty {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                    li {
                        border-bottom: 1px solid #E6E6E6;
                        display: flex;
                        justify-content: space-between;
                        padding: 15px 0;
                        .title {
                            display: inline-block;
                            /* width: 940px; */
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            cursor: pointer;
                        }
                        .look {
                            width: 20%;
                            text-align: right;
                            span {
                                /* border: 1px solid #1A68E8; */
                                padding: 5px 10px;
                                color: #1A68E8;
                            }
                        }
                    }
                    /deep/ .el-pagination {
                        display: flex;
                        justify-content: center;
                        margin-top: 20px;
                    }
                    /deep/ .el-pager li {
                        background: #fff;
                        border: 1px solid #ddd;
                        border-radius: 1px;
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        width: 34px;
                    }
                    /deep/ .el-pager li:nth-of-type(n+2) {
                        border-left: none;
                    }
                    /deep/ .btn-next {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-left: none;
                    }
                    /deep/ .btn-prev {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-right: none;
                    }
                    /deep/ .el-pager li:not(.disabled).active {
                        background-color: #1A68E8;
                    }
                }
            }
        }
    }
}
</style>
